import type { ColorScheme } from '../../types';
import { BLACK, WHITE } from './colors';

export const getTextColor = (textColor: string, colorScheme: ColorScheme) => {
  if (colorScheme === 'light') {
    return BLACK;
  }

  if (colorScheme === 'dark') {
    return WHITE;
  }

  return textColor;
};
